export const replaceBrandName = (value: string, brandName: string) =>
    brandName === '40Seas' ? value : value.replace(/40seas/gi, brandName);
